import { Redirect } from "react-router"
import { myLazy } from "utils/myLazy"
import { GooglePageViewTypes } from "utils/googleAnalytics/googleAnalyticsPageViewEvent"

export const adminGuestRoutes = [
  //===================================================================
  //7.1 News
  {
    exact: true,
    path: "/admin/guest/news/list",
    component: myLazy(() => import("views/admin/news/List")),
    googleAnalyticsPageType: GooglePageViewTypes.NEWS,
    pageTitle: "Blog"
  },
  {
    exact: false,
    path: "/admin/guest/news/form",
    component: myLazy(() => import("views/admin/news/articleForm")),
    googleAnalyticsPageType: GooglePageViewTypes.NEWS,
    pageTitle: "Blog"
  },
  //===================================================================
  //tutorials
  {
    exact: true,
    path: "/admin/guest/tutorials/list",
    component: myLazy(() => import("views/admin/tutorials/tutorialList")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Tutoriale"
  },
  {
    exact: false,
    path: "/admin/guest/tutorials/form",
    component: myLazy(() => import("views/admin/tutorials/tutorialForm")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Tutoriale"
  },
  //7.2 Jobs - list and form
  {
    exact: true,
    path: "/admin/guest/job/list",
    component: myLazy(() => import("views/admin/avaliableJobs/avaliableJobs")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Anunțuri de job"
  },
  {
    exact: false,
    path: "/admin/guest/job/form",
    component: myLazy(() => import("views/admin/avaliableJobs/addJob")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Anunțuri de job"
  },

  //===================================================================
  //7.3 Aplicanti
  {
    exact: true,
    path: "/admin/guest/candidate/list",
    component: myLazy(() => import("views/admin/aplicanti/List")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Aplicanți job-uri"
  },
  {
    exact: false,
    path: "/admin/guest/candidate/form",
    component: myLazy(() => import("views/admin/aplicanti/applicantFormPage")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Aplicanți job-uri"
  },
  //===================================================================
  //7.4 Contact - list and form
  {
    exact: true,
    path: "/admin/guest/contact/list",
    component: myLazy(() => import("views/admin/contactListAndForm/contactList")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Cereri de contact"
  },
  {
    exact: false,
    path: "/admin/guest/contact/form",
    component: myLazy(() => import("views/admin/contactListAndForm/contactForm")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Cereri de contact"
  },

  //===================================================================
  //7.5 Locatii uniprest
  {
    exact: true,
    path: "/admin/guest/location/list",
    component: myLazy(() => import("views/admin/location/List")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Locații Uniprest Instal"
  },
  {
    exact: false,
    path: "/admin/guest/location/form",
    component: myLazy(() => import("views/admin/location/LocationForm.jsx")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Locații Uniprest Instal"
  },

  //===================================================================
  {
    exact: true,
    path: "/admin/guest/dashboard",
    component: myLazy(() => import("views/admin/unifiedDashboard")),
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Dashboard"
  },
  {
    exact: false,
    path: "/admin/guest",
    component: () => <Redirect to="/admin/guest/dashboard" />,
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Dashboard"
  }
]
